import React, { useEffect, useState } from 'react';
import { getSubscriptionPlans } from 'services/subscriptionPlanService';
import { toast } from 'react-toastify';
const Pricing = ()=>{
    const [subscriptionPlans, setSubscriptionPlans] = useState([]);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
        const fetchSubscriptionPlans = async () => {
            const response = await getSubscriptionPlans();

            if(response.success){
                setSubscriptionPlans(response.data);
            } else {
                toast.error('Failed to load subscription plans. Please try again later.');
            }
            setLoading(false);

        };

        fetchSubscriptionPlans();
    }, []);

    return(
        <section className="bg-indigo-50 py-16 mt-10">
            <div className="max-w-5xl mx-auto px-6 text-center">
                <h3 className="text-2xl font-bold text-gray-900">Simple pricing for growing car washes</h3>
                <p className="mt-2 text-gray-600 max-w-2xl mx-auto">Start free. Upgrade as you grow — cancel anytime.</p>

                {loading ? (
                    <div className="mt-8">Loading subscription plans...</div>
                ) : (
                    <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-6">
                        {subscriptionPlans.map((plan) => (
                            <div className={`bg-white rounded-lg p-6 shadow border border-gray-100 ${plan.inDemand? 'border-indigo-600':'border-gray-100'}`}>
                                <div className="text-sm font-semibold text-gray-700">{plan.name}</div>
                                <div className="mt-4 text-3xl font-extrabold text-gray-900">R{plan.monthlyAmount}<span className="text-base font-medium">/mo</span></div>
                                <p className="mt-3 text-sm text-gray-600">
                                    {plan?.shortDescription}
                                </p>
                                <a href="/sign-up" className="mt-6 inline-block px-4 py-2 rounded-full bg-indigo-600 text-white text-sm">Get Started</a>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}

export default Pricing;